import app from "../_app";
import cookie from "./_cookie";
import {initPopupTriggers, initVariantsButtons} from "./product";


const relatedPopup = document.querySelector('.js-related-popup');
const relatedPopupContent = document.querySelector('.js-related-popup-content');
const sizeGuideContent = document.querySelector('.js-size-guide-content');

export const openrelatedPopupHandler = (product) => {
    if(relatedPopup) {
        app.lockBody();
        const AddType = product.dataset.type;

        // Check if product was allrady added.
        if(product.classList.contains('checked')){
            const formDynamicAttribute = document.querySelector('.js-product-form');
            const variantIds = product.dataset.variantids ? product.dataset.variantids.split(',') : '';
            let dynamicAdded = false;


            if(formDynamicAttribute && AddType != 'direct') {
                dynamicAdded = formDynamicAttribute.getAttribute('data-dynamic-variant').split(',');
            }

            const upsellElement = document.querySelector('.js-upsell[data-id="'+ product.dataset.productid +'"]');
            const relatedVariantsProducts = [...document.querySelectorAll('.js-product-related-variant')];

            if(dynamicAdded != false) {
                variantIds.forEach(value => {
                    let index = dynamicAdded.indexOf(value);

                    if (index !== -1) {
                        dynamicAdded.splice(index, 1);
                    }
                });

                formDynamicAttribute.setAttribute('data-dynamic-variant', dynamicAdded);
                upsellElement.classList.add('d-none');
                upsellElement.querySelector('.js-upsell-size').innerHTML = '';
            }
            product.classList.remove('checked');

            relatedVariantsProducts.map((relatedProduct) => {
                relatedProduct.checked = false;
            });
            app.unlockBody();

        }else {
            // Product was not added, so now we open the modal and add the product.
            relatedPopup.setAttribute('data-open', '');
            relatedPopup.setAttribute('data-id', product.dataset.productid);
            relatedPopup.querySelector('.js-related-popup-title').innerHTML = product.dataset.title;
            if(AddType != 'direct') {
                product.classList.add('checked');
            }

            async function fetchProducts() {
                const currentProduct = product.dataset.id;

                try {
                    const response = await fetch(`${Shopify.routes.root}products/${currentProduct}?section_id=product-variants-by-id`);
                    const html = await response.text();

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const productData = doc.querySelector('.js-product-data');

                    if (productData) {

                        relatedPopupContent.innerHTML = productData.innerHTML;
                        initPopupTriggers();
                        initVariantsButtons(AddType);

                        const sizeGuidelink = relatedPopupContent.querySelector('.js-pdp-popup');

                        if (sizeGuidelink?.dataset.dynamic) {
                            const pageHandle = sizeGuidelink.dataset.dynamic;

                            async function fetchSizeGuide() {

                                try {
                                    const response = await fetch(`${Shopify.routes.root}pages/${pageHandle}?section_id=page-content-by-handle`);
                                    const html = await response.text();

                                    const parser = new DOMParser();
                                    const doc = parser.parseFromString(html, 'text/html');
                                    const pageData = doc.querySelector('.js-page-data');

                                    if (pageData) {
                                        sizeGuideContent.innerHTML = pageData.innerHTML;
                                    }

                                } catch (error) {
                                    console.error(error);
                                }
                            }

                            fetchSizeGuide();
                        }
                    }

                } catch (error) {
                    console.error(error);
                }
            }

            fetchProducts();
        }

    }
};
export const closerelatedPopupHandler = (product) => {

    const relatedWrapper = document.querySelector('.pdp__related');
    let relatedProducts = false;
    if (relatedWrapper) {
        relatedProducts = [...relatedWrapper.querySelectorAll('.js-related-popup-trigger')];
    }

    if(product) {
       if(relatedProducts) {
           relatedProducts.map(relatedProduct => {
               if (relatedProduct.dataset.productid === product.closest('.js-related-popup').dataset.id) {
                   relatedProduct.classList.remove('checked');
               }
           });
       }
        product.classList.remove('checked');
    }
    relatedPopup.removeAttribute('data-open');
    app.unlockBody();
};

if(relatedPopup) {
    const closeTriggers = [...relatedPopup.querySelectorAll('.js-related-popup-close')];
    closeTriggers.map(closeTrigger => {
        closeTrigger.addEventListener('click', () => {
            closerelatedPopupHandler(closeTrigger);
        });
    });
}

export const relatedPopupTriggers = () => {
    const relatedPopupTriggers = [...document.querySelectorAll('.js-related-popup-trigger')];
    relatedPopupTriggers.map(relatedPopupTrigger => {

        relatedPopupTrigger.addEventListener('click', () => {
            openrelatedPopupHandler(relatedPopupTrigger);
        });
    });
}
relatedPopupTriggers();
